/**
 * registered-bureaux
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

/**
 * @param {Sandbox} sb
 */
export default sb => {
    let tbody;

    const renderTableBody = bureaux => {
        const html = bureaux.map((bureau, i) => {
            let row = [];

            let link = bureau.web_address
                ? bureau.web_address.replace(/http:\/\//, "")
                : false;
            link = link
                ? `<a href="http://${link}" target="_blank">${link}</a>`
                : false;

            row.push(`<tr ${i % 2 !== 0 ? "class=\"odd\"" : "class=\"even\""}>`);

            // Company name and URL
            row.push("<td>");
            row.push(`<div class="company_name">${bureau.company_name}</div>`);
            if (link) {
                row.push(`<div class="company_website">${link}</div>`);
            }
            row.push("</td>");

            // Postal address
            row.push("<td>");
            if (bureau.post_address) {
                row.push(bureau.post_address.replace(/(?:, ([A-Z])|\r?\n)/g, "<span><br></span>$1 "));
            }
            row.push("</td>");

            // Telephone number
            row.push("<td>" + (bureau.telephone || "") + "</td>");

            // Contact name and email address
            row.push("<td>");
            if (bureau.contact_name) {
                row.push(`<div class="contact_name">${bureau.contact_name}</div>`);
            }
            if (bureau.contact_email) {
                row.push(`<div class="contact_email"><a href="mailto:${bureau.contact_email}">${bureau.contact_email}</a></div>`);
            }
            row.push("</td>");

            row.push("</tr>");

            return row.join("\n");
        }).join("\n");

        sb.append(tbody, html);
    };

    return {
        init() {
            tbody = sb.find("tbody");

            sb.postApi("/resources/registered-bureaux").then(renderTableBody);
        },
        destroy() {
            tbody = null;
        }
    };
};
